var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageName === 'home')?_c('img',{staticClass:"w-4/5 h-4/5",attrs:{"src":require("@/assets/illustrations/activity-empty-state.svg"),"alt":"empty state"}}):_vm._e(),(_vm.pageName === 'activity-detail')?_c('img',{staticClass:"w-4/5 h-4/5",attrs:{"src":require("@/assets/illustrations/todo-empty-state.svg"),"alt":"empty state"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }